import { render, staticRenderFns } from "./DocumentosCita.vue?vue&type=template&id=7f3bf080"
import script from "./DocumentosCita.vue?vue&type=script&lang=js"
export * from "./DocumentosCita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports